import React from 'react';
import { NavItem } from './NavItem';
import type { NavItemType } from '../../types/navigation';

interface MobileMenuProps {
  items: readonly NavItemType[];
  currentPath: string;
  onItemClick: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ 
  items, 
  currentPath,
  onItemClick 
}) => {
  return (
    <div className="md:hidden py-2">
      {items.map((item) => (
        <NavItem
          key={item.path}
          item={item}
          isActive={currentPath === item.path}
          isMobile
          onClick={onItemClick}
        />
      ))}
    </div>
  );
};